import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { auth, logout } from "../store/actions/index";

import companyLogo from "../assets/login-logo.png";
import headerLogo from "../assets/header-logo.png";
import doctorLogo from "../assets/dr-logo.jpg";
import emailLogo from "../assets/email.png";
import lockLogo from "../assets/lockCopy@2x.png";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const logInButtonRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const error = useSelector((state) => state.auth.error);

  useEffect(() => {
    dispatch(logout()); // Call logout on mount
    if (logInButtonRef.current) {
      logInButtonRef.current.focus(); // Focus the login button on mount
    }
  }, [dispatch]);

  const submitHandler = async (event) => {
    event.preventDefault();
    const response = await dispatch(auth(email, password));

    if (response?.id_token) {
      if (response.isAdmin) navigate("/admin/dashboard");
      else navigate("/dashboard");
    } else {
      alert(error);
      navigate("/login");
    }
  };

  return (
    <form onSubmit={submitHandler} className="login">
      <div className="login-logo-cont">
        <div className="logo">
          <img src={companyLogo} width="100%" alt="logo" />
        </div>
        <h1 className="mt-50">Healthcare Management</h1>
        <p>
          Welcome! An easy to use application that allows you to manage your
          practice billing and revenue management cycle effectively.
        </p>
        <a
          href="https://orcicare.com/providers/"
          target="_blank"
          rel="noreferrer"
        >
          <div className="margin-center mt-50 learn-more-btn">Learn more</div>
        </a>
      </div>
      <div className="login-right">
        <div className="right-logo">
          <img src={headerLogo} alt="Logo" />
        </div>
        <div className="text-center">
          <img src={doctorLogo} alt="Doctor Logo" height={80} />
        </div>
        <div className="text-center">
          <h1>Welcome. Let`s get started</h1>
          <p className="details">Please enter your details below</p>
        </div>
        <div className="login-form">
          <div className="input-group">
            <span>
              <img
                src={emailLogo}
                alt="logo"
                style={{ marginBottom: "-20px" }}
              />
            </span>
            <input
              type="email"
              placeholder="E-Mail *"
              aria-label="Email"
              value={email}
              aria-describedby="basic-addon1"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-group">
            <span>
              <img src={lockLogo} alt="logo" />
            </span>
            <input
              type="password"
              placeholder="Password *"
              aria-label="Password"
              value={password}
              aria-describedby="basic-addon1"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="text-center mt-50">
            <button type="submit" className="submit" ref={logInButtonRef}>
              Sign In
            </button>
          </div>
          <div className="text-center mt-50 mb-50">
            {/* eslint-disable-next-line */}
            <a href="#">Forgot your password?</a>
          </div>
          <div className="text-center">
            By creating your account you are agreeing
            <br />
            with our
            <span className="cyan-color cursor" target="_blank">
              {" "}
              Terms and Conditions
            </span>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Auth;
